const TABS = [
    { id: 'verify', label: 'Verify', icon: 'bi-search' },
    { id: 'history', label: 'Verification History', icon: 'bi-clock-history' }
];

const VERIFICATION_FORMS = [
    {
        id: 'id',
        title: 'ID Number Verification',
        description: 'Validate SA ID numbers against Home Affairs',
        icon: 'bi-person-vcard',
        icon_class: 'text-success',
        field_label: 'SA ID Number',
        field_placeholder: 'Enter 13-digit ID number',
        button_text: 'Verify ID',
        model: 'id_number'
    },
    {
        id: 'company',
        title: 'Company Verification',
        description: 'Verify company registration via CIPC',
        icon: 'bi-building',
        icon_class: 'text-success',
        field_label: 'Registration Number',
        field_placeholder: 'e.g., 2020/123456/07',
        button_text: 'Verify Company',
        model: 'company_number'
    },
    {
        id: 'certificate',
        title: 'BEE Certificate Verification',
        description: 'Validate BEE certificates via SANAS agencies',
        icon: 'bi-award',
        icon_class: 'text-success',
        field_label: 'Certificate Number',
        field_placeholder: 'e.g., BEE-2024-00456',
        button_text: 'Verify Certificate',
        model: 'certificate_number'
    }
];

const HISTORY_COLUMNS = [
    { key: 'type', label: 'Type' },
    { key: 'reference', label: 'Reference' },
    { key: 'name', label: 'Name' },
    { key: 'source', label: 'Source' },
    { key: 'status', label: 'Status' },
    { key: 'verified_at', label: 'Verified At' }
];

const INTEGRATIONS = [
    {
        id: 1,
        title: 'Home Affairs ID Verification',
        description: 'Validate South African ID numbers against the Department of Home Affairs database',
        icon: 'bi-shield-check',
        icon_color_class: 'text-success',
        icon_bg_class: 'bg-success-subtle',
        status_text: 'Connected',
        status_class: 'bg-success text-dark',
        status_icon: 'bi-check-circle',
        last_sync: '2024-01-15 14:32'
    },
    {
        id: 2,
        title: 'CIPC Company Registry',
        description: 'Verify company registration details with CIPC',
        icon: 'bi-building',
        icon_color_class: 'text-primary',
        icon_bg_class: 'bg-primary-subtle',
        status_text: 'Connected',
        status_class: 'bg-success text-dark',
        status_icon: 'bi-check-circle',
        last_sync: '2024-01-14 09:15'
    },
    {
        id: 3,
        title: 'SANAS BEE Verification',
        description: 'Validate BEE certificates through SANAS accredited agencies',
        icon: 'bi-award',
        icon_color_class: 'text-success',
        icon_bg_class: 'bg-success-subtle',
        status_text: 'Connected',
        status_class: 'bg-success text-dark',
        status_icon: 'bi-check-circle',
        last_sync: '2024-01-12 11:45'
    },
    {
        id: 4,
        title: 'SARS Tax Clearance',
        description: 'Verify tax compliance status with SARS',
        icon: 'bi-receipt',
        icon_color_class: 'text-warning',
        icon_bg_class: 'bg-warning-subtle',
        status_text: 'Pending',
        status_class: 'bg-warning text-dark',
        status_icon: 'bi-clock',
        last_sync: '—'
    }
];

const VERIFICATION_HISTORY = [
    {
        id: 1,
        type: 'ID Verification',
        reference: '9001015800086',
        name: 'John Doe',
        source: 'Home Affairs API',
        status: 'Verified',
        status_class: 'bg-success text-dark',
        status_icon: 'bi-check-circle',
        verified_at: '2024-01-15 14:32'
    },
    {
        id: 2,
        type: 'Company Verification',
        reference: '2020/123456/07',
        name: 'ABC Suppliers (Pty) Ltd',
        source: 'CIPC API',
        status: 'Verified',
        status_class: 'bg-success text-dark',
        status_icon: 'bi-check-circle',
        verified_at: '2024-01-14 09:15'
    },
    {
        id: 3,
        type: 'ID Verification',
        reference: '8505205800083',
        name: 'Jane Smith',
        source: 'Home Affairs API',
        status: 'Pending',
        status_class: 'bg-warning text-dark',
        status_icon: 'bi-clock',
        verified_at: '—'
    }
];

const clone_list = (list) => list.map((item) => ({ ...item }));
const integration_history_table_helpers = window.global_data_table?.create_component_helpers({
    active_tab_key: 'active_tab',
    visible_flag_key: 'is_integration_view',
    data_key_to_watch: 'verification_history',
    required_tab_value: 'history',
    selector: '.global_data_table'
}) || {};

export default {
    name: "IntegrationComponent",
    props: {
        is_integration_view: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return ({
            page_title: 'Government Integration',
            page_subtitle: 'Validate IDs, supplier details, and receive verification confirmations via government APIs',
            active_tab: 'verify',
            id_number: '',
            company_number: '',
            certificate_number: '',
            tabs: clone_list(TABS),
            verification_forms: clone_list(VERIFICATION_FORMS),
            notice_title: 'Integration Notice',
            notice_text: 'This is a proof of concept. In production, these integrations will connect directly to government APIs including Home Affairs, CIPC, SANAS, and SARS for real-time verification of identity documents, company registrations, BEE certificates, and tax compliance status.',
            history_title: 'Verification History',
            history_subtitle: 'Recent verification requests and their results',
            history_columns: clone_list(HISTORY_COLUMNS),
            integrations: clone_list(INTEGRATIONS),
            verification_history: clone_list(VERIFICATION_HISTORY)
        });
    },
    mounted: integration_history_table_helpers.mounted,
    beforeUnmount: integration_history_table_helpers.beforeUnmount,
    watch: {
        ...(integration_history_table_helpers.watch || {})
    },
    methods: {
        ...(integration_history_table_helpers.methods || {})
    }
};
